export interface IAlleleOverride {
    id: number;
    donorAlleleId: number;
    recipientAlleleId: number;
    needsOverride: boolean;
    whichField: string;
    oldValue: number;
    whenOverridden: string;
    comments: string;
}